import { schema } from 'normalizr'

// Members
const memberSchema = new schema.Entity('members')

// Authentication
const userSchema = new schema.Entity('users')
userSchema.define({ member: memberSchema })

export { memberSchema, userSchema }
